const extraData = [
  {
    id: 1,
    name: "CSEC-NITH:",
    link: "https://www.linkedin.com/company/nith-csec/",
    website: "https://codeforces.com/group/Mka6Tznt4j/blog",
    details: [
      {
        info: "Volunteer at Computer Science Engineer's Community of NITH"
      },
      {
        info: `Member of Csec's monthly programming contest HEURISTICS  on codeforces.`
      },
      { info: "Used Polygen (Codeforces) to set competitive problems." }
    ],
    timeline: "Mar 2020 - Present"
  },
  {
    id: 1,
    name: "GLUG-NITH:",
    link: "https://www.linkedin.com/groups/6683789/",
    details: [
      {
        info:
          "Active volunteer at GLUG-NITH, which is a community aimed at improving the coding culture at NIT-H"
      },
      {
        info:
          "Collaborated with team members using version control systems such as Git to organize modifications and assign tasks."
      },
      { info: "Utilized VS Code as a development environment" }
    ],
    timeline: "Mar 2020 - Present"
  },
  {
    id: 1,
    name: "LEAN IN:",
    link: "https://www.linkedin.com/company/lean-in-nit-hamirpur/",
    details: [
      {
        info: "Mentee at Women in Technology Circle of NITH"
      },
      {
        info: "Actively attending meets and Solving coding problems."
      }
    ],
    timeline: "Aug 2020 - Nov. 2021"
  }
];

export default extraData;
